// @flow

import React, { useEffect, useState } from 'react'

import { Shop } from '../../../../../../../../models'

import { PanelInput } from '../../../common/PanelInput'

type Props = {
  shop: Shop,
  onChange: (payload: any) => void,
  onValidate: (isValid: boolean) => void
}

export function Custom ({ shop, onChange, onValidate }: Props) {
  const [url, setUrl] = useState(shop.custom_config.integrations?.custom?.url)
  const [username, setUsername] = useState(shop.custom_config.integrations?.custom?.username)
  const [password, setPassword] = useState(shop.custom_config.integrations?.custom?.password)

  function validate (): boolean {
    return url && username && password
  }

  useEffect(() => {
    onChange({ url, username, password })
    onValidate(validate())
  }, [url, username, password])

  return (
    <>
      <PanelInput
        value={url}
        title="Order Status Endpoint (URL)"
        placeholder="https://www.example.com"
        onChange={value => setUrl(value)}
      />
      <PanelInput
        value={username}
        title="Username"
        placeholder="demo"
        onChange={value => setUsername(value)}
      />
      <PanelInput
        value={password}
        title="API Token / Password"
        placeholder="1234567890"
        onChange={value => setPassword(value)}
      />
    </>
  )
}
